import { prop } from 'datx';

import { BaseModel } from './BaseModel';

export class OptionValue extends BaseModel {
  public static type = 'optionValue';

  @prop
  public uid!: string;

  @prop
  public pickerValue!: any;

  @prop
  public genderId!: number;

  @prop
  public isSelected!: boolean;
}
